<div class="container barChartContainer" [ngClass]="{ loadingContainer: loading() || timeOut() }">
  <span class="energyToolWidgetTitle">{{ "energy_tool.bar_chart.title" | translate }} </span>
  @if (chartId()) {
    <div class="chartWrapper">
      <canvas [ngClass]="{ hide: loading() }" class="chart" [id]="chartId()"></canvas>
    </div>
  }
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  } @else {
    <div class="chartFilter">
      <div class="timeWindow">
        <span class="pointer" (click)="previousTimeWindow()">&lt;</span>
        <p-floatLabel>
          <p-datepicker
            [showWeek]="true"
            [firstDayOfWeek]="1"
            [(ngModel)]="date"
            [view]="calendarView"
            [dateFormat]="dateFormat"
            [readonlyInput]="true"
            inputId="date"
            (onSelect)="setTimeWindow()"
            appendTo="body"
          >
          </p-datepicker>
          <label for="date">{{ "energy_tool.bar_chart.time_window" | translate }}</label>
        </p-floatLabel>
        <span class="pointer" (click)="nextTimeWindow()">&gt;</span>
      </div>
      <div class="aggregationOptions">
        @for (option of filterAggregationOptions; track option) {
          <span
            [ngClass]="{
              selected: currentFilterAggregation === option.value,
              borderLeft: $index !== 0,
            }"
            (click)="clickAggregationOption(option.value)"
          >
            {{ option.label | translate }}
          </span>
        }
      </div>
    </div>
  }
</div>
